<template>
  <div class="sub flex center gaps">
    <!-- CSVへ出力 -->
    <div class="box">
      <el-button
        :loading="isExporting"
        :type="isExporting ? 'info' : 'plain'"
        :disabled="!total"
        size="mini"
        plain
        round
        @click="exportOrders"
      >
        {{ isExporting ? "CSVへ出力中" : "CSVへ出力" }}
      </el-button>
    </div>

    <!-- 件数表示 -->
    <div class="box">
      <template v-if="total">
        {{ total }}
        <small>件中、</small>
        {{ computedOrderFrom }}〜{{ computedOrderTo }}
        <small>件を表示しています</small>
      </template>
      <template v-else>
        {{ total }} <small>件</small>
      </template>
    </div>

    <!-- スペース埋め -->
    <div class="box grow" />

    <!-- 絞り込み解除 -->
    <div class="box">
      <el-button
        v-if="isFiltered"
        icon="el-icon-close"
        size="mini"
        type="text"
        plain
        round
        @click="$emit('onClearFilterConditions')"
      >
        条件をクリア
      </el-button>
    </div>

    <!-- 絞り込み -->
    <div class="box">
      <el-button
        icon="el-icon-search"
        size="mini"
        :type="isFiltered ? 'primary' : 'plain'"
        :plain="isFiltered"
        round
        @click="localIsShowFilterModal = true"
      >
        絞り込み
      </el-button>

      <slot name="filterModal" />
    </div>

    <!-- 担当注文のみ -->
    <div class="box">
      <div
        class="switchButton flex center"
        :class="{
          active: localIsOnlyOrdersInCharge,
        }"
        @click="toggleLocalIsOnlyOrdersInCharge"
      >
        <div class="switchButtonCover" />

        <div class="box">
          担当注文のみ
        </div>
        <div class="box">
          <el-switch
            v-model="localIsOnlyOrdersInCharge"
            active-color="#409EFF"
            inactive-color="#C0C4CC"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeSub",
  props: {
    total: Number,
    currentPage: Number,
    pageSize: Number,
    isShowFilterModal: Boolean,
    isExporting: Boolean,
    isFiltered: Boolean,
    isOnlyOrdersInCharge: Boolean,
  },
  data () {
    return {
    };
  },
  computed: {
    computedOrderFrom () {
      const {
        currentPage,
        pageSize,
      } = this;

      return (currentPage - 1) * pageSize + 1;
    },
    computedOrderTo () {
      const {
        total,
        currentPage,
        pageSize,
      } = this;

      return Math.min(currentPage * pageSize, total);
    },
    localIsShowFilterModal: {
      get () {
        return this.isShowFilterModal;
      },
      set (value) {
        this.$emit("update:isShowFilterModal", value);
      },
    },
    localIsOnlyOrdersInCharge: {
      get () {
        return this.isOnlyOrdersInCharge;
      },
      set (value) {
        this.$emit("update:isOnlyOrdersInCharge", value);
      },
    },
  },
  watch: {
  },
  created () {
  },
  mounted () {
  },
  methods: {
    /**
     * [exportOrders description]
     */
    exportOrders () {
      if (window.confirm("CSVへの出力を行いますか？")) {
        this.$emit("onExportOrders");
      }
    },

    /**
     * [toggleLocalIsOnlyOrdersInCharge description]
     */
    toggleLocalIsOnlyOrdersInCharge () {
      this.localIsOnlyOrdersInCharge = !this.localIsOnlyOrdersInCharge;

      this.$emit("onChangeStatus");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.sub {
  padding: 3px 16px 12px 15px;

  .switchButton {
    position: relative;
    height: 28.5px;
    padding: 0 10px 0 12px;
    box-sizing: border-box;
    border: 1px solid $--border-color-base;
    border-radius: 100px;
    font-size: 12px;

    &.active {
      color: $--color-primary;
      background: #ecf5ff;
      border-color: #b3d8ff;
    }

    &Cover {
      height: 100%;
      width: 100%;
      position: absolute;
      left: 0;
      border-radius: 100px;
      z-index: 1;
    }

    .el-switch {
      transform: scale(0.75);
      transform-origin: 100% 50%;
    }
  }
}
</style>
